import * as React from "react"
import Hero from "./Hero"
import Contact from "./Contacts"
import Quality from "./Quality"
import Showcase from "./Showcase"
import Skills from "./Skills"
import Tools from "./Tools"
import { theme, vh, rx, rr } from "../../styles/styleGuide"
import styled from "@emotion/styled"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { EffectFade } from "swiper"
import lottie from "lottie-web"
SwiperCore.use([EffectFade])
// import "swiper/swiper.scss"
// import "swiper/components/effect-fade/effect-fade.scss"
var isBrowser = typeof window !== "undefined"
gsap.registerPlugin(ScrollTrigger)
var color = theme.color,
  slides = {
    hero: [0, 0, 0],
    skills: [100, 400, 0],
    quality: [100, 100, 0],
    showcase: [100, 300, 0],
    tools: [100, 500, 0],
    contacts: [100, 0, 0],
  },
  slidesTimeline: any,
  progress = 0,
  tweener = gsap
function Animator() {
  React.useEffect(() => {
    //**?--------------- Intial States --------------- */
    //#region [c1]

    //** ------------------ Videos pause & Play {css Prop} ----------------------- */
    gsap.set("video", { fontStyle: "initial" })
    //** ------------------ Inital scroll Block ----------------------- */
    // gsap.set("#___gatsby", { pointerEvents: "none" })
    //** ------------------ Hero ----------------------- */
    gsap.set("#hero #title .upper .figure", { opacity: 0, x: "-20%" })
    gsap.set("#hero #title .lower .figure", { rotate: 10, y: "30%", opacity: 0 })
    gsap.set("#hero #title .tag-line .text .figure", { visibility: "hidden" })
    gsap.set("#hero #title .tag-line .line ", {
      visibility: "hidden",
      x: rx("vw", -67, -60, -55),
    })
    gsap.set("#hero .scroll-icon", { visibility: "hidden" })
    //** ------------------ Sections Slide Title ----------------------- */
    gsap.set(
      [
        "#skills .section-title",
        "#showcase .section-title",
        "#tools .section-title",
        "#contacts .section-title",
      ],
      {
        y: vh(92),
      }
    )
    //** ------------------ Sections Clip ----------------------- */
    gsap.set(
      ["#skills .clip", "#showcase .clip", "#tools .clip", "#contacts .clip", "#quality .clip"],
      {
        clipPath: "inset(100% 0% 0% 0%)",
      }
    )
    //** ------------------ Sections PointerEvents For Clicking ----------------------- */
    gsap.set(["#skills ", "#showcase ", "#tools ", "#contacts ", "#quality"], {
      pointerEvents: "none",
    })
    //** ------------------ Skills ----------------------- */
    gsap.set("#skills #design-slide .title .upper .figure", {
      color: color.red,
    })
    gsap.set("#skills .figure", { y: "100%", rotate: 30, opacity: 0 })
    gsap.set("#skills .description", { opacity: 0 })
    gsap.set("#skills #design-slide  .description", { opacity: 1 })
    gsap.set("#skills #design-slide .figure", { y: "0%", rotate: 0, opacity: 1 })
    //** ------------------ Quality ----------------------- */
    gsap.set("#quality .section-title", { y: vh(91.5) })
    gsap.set("#quality .parts .q", { scale: 1, x: "-0.5em", y: 0 })
    gsap.set("#quality .parts .yellow", { scale: 1 })
    gsap.set("#quality .parts ", {
      scale: 0.8,
      x: rx("%", 13, 8, 8),
      y: rx("%", 0.6, 0.6, 8),
    })
    gsap.set("#quality .parts .line-0", { x: "-8%" })
    gsap.set("#quality .parts .line-2", { x: "0%" })
    gsap.set("#quality .parts .line-3", { x: "30%" })
    gsap.set("#quality .uality .figure", { x: "-100%" })
    //** ------------------ Showcase ----------------------- */
    gsap.set("#showcase video", { display: "none", opacity: 0 })
    //** ------------------ Slides Initially {display: none} ----------------------- */
    gsap.set(["#skills", "#quality", "#showcase", "#tools", "#contacts"], { display: "none" })
    //#endregion
    //**?--------------- Sections Reveal --------------- */
    //#region [c2]
    type slides = "hero" | "skills" | "quality" | "showcase" | "tools" | "contacts"
    var BrowserBar = document.querySelector('[name="theme-color"]')
    const plusButtonColor = (
      slideColor: { primary: string; background: string },
      duration: number
    ) => {
      var tw = gsap
        .timeline()
        .add("l1")
        .to(
          "#plus-container #plus-button",
          {
            backgroundColor: slideColor.primary,
            duration,
          },
          "l1"
        )
        .to(
          "#plus-container #plus-button .text",
          { backgroundColor: slideColor.background, duration },
          "l1"
        )
        .set(BrowserBar, { delay: -0.2 * duration, attr: { content: slideColor.primary } })
      return tw.totalDuration(duration)
    }
    var plusButton = {
      reveal: {
        hero: plusButtonColor(color.hero.cover, 0.2),
        skills: plusButtonColor(color.skills.cover, 0.2),
        quality: plusButtonColor(color.quality.cover, 0.2),
        showcase: plusButtonColor(color.showcase.cover, 0.2),
        tools: plusButtonColor(color.tools.cover, 0.2),
        contacts: plusButtonColor(color.contacts.cover, 0.2),
      },
    }

    const sectionReveal = (el: slides, prev: slides = "hero") => {
      var tl = gsap.timeline({
        defaults: { ease: "none" },
      })

      if (el && el !== "quality") {
        tl.set(`#${el}`, { display: "initial" })
          .add("l1")
          .to(`#${el} .section-title`, { duration: 1, y: vh(1) }, "l1")
          .to(`#${el} .clip`, { duration: 1, clipPath: "inset(10% 0% 0% 0%)" }, "l1")
          .add(plusButton.reveal[el], "-=0.1")
          .set(`#${el}`, { delay: -0.1, pointerEvents: "all" })
          .set(`#${prev} video`, { display: "none", fontStyle: "initial" })
          .set(`#${prev}`, { display: "none" })
      } else if (el === "quality") {
        tl.set(`#${el}`, { display: "initial" })
          .add("l1")
          .to(`#${el} .section-title`, { duration: 1, y: vh(-4) }, "l1")
          .to(`#${el} .clip`, { duration: 1, clipPath: "inset(0% 0% 0% 0%)" }, "l1")
          .add(plusButton.reveal[el], "-=0.1")
          .set(`#${el}`, { delay: -0.1, pointerEvents: "all" })
          .set(`#${prev} video`, { display: "none", fontStyle: "initial" })
          .set(`#${prev}`, { display: "none" })
      }
      return tl.totalDuration(slides[el][0])
    }
    var reveal = {
      skills: sectionReveal("skills", "hero"),
      quality: sectionReveal("quality", "skills"),
      showcase: sectionReveal("showcase"),
      tools: sectionReveal("tools", "showcase"),
      contacts: sectionReveal("contacts"),
    }

    //#endregion
    //**TODO --------------- Hero & Intro --------------- */
    //#region [c3]

    var signature = document.querySelector("#signature")
    var lt = lottie.loadAnimation({
      container: signature!,
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: "https://assets10.lottiefiles.com/private_files/lf30_khcrxpjp.json",
    })

    var starter = gsap
      .timeline({ paused: true })
      .set(BrowserBar, { attr: { content: color.black } })
      .to("#loading .loading", {
        duration: 0.2,
        opacity: 0,
        onComplete: () => {
          lt.play()
        },
      })
      .set(BrowserBar, { attr: { content: color.black } })
    lt.addEventListener("complete", () => {
      gsap
        .timeline()
        .set("#plus-button", { y: vh(-90) }, "l1")
        .set("#hero video", { display: "none" })
        .to("#loading #signature", {
          delay: 0.7,
          duration: 1,
          ease: "expo.in",
          clipPath: "inset(49.8% 0% 49.8% 0%)",
        })
        .set(BrowserBar, { attr: { content: color.white } })
        .to("#loading #signature", {
          duration: 0.3,
          ease: "expo.out",
          width: 0,
        })
        .set("#loading", { display: "none", pointerEvents: "none" })
        .to("#hero #title .upper .figure", {
          stagger: 0.04,
          x: 0,
          opacity: 1,
          ease: "expo.out",
        })
        .to("#hero #title .lower .figure", {
          delay: -0.5,
          stagger: 0.02,
          y: 0,
          rotate: 0,
          opacity: 1,
          ease: "expo.inOut",
        })
        .to("#hero #title .tag-line .line ", { duration: 0.05, visibility: "visible" })
        .to("#hero #title .tag-line .line ", { duration: 0.05, visibility: "hidden" })
        .to("#hero #title .tag-line .line ", { duration: 0.05, visibility: "visible" })
        .to("#hero #title .tag-line .line ", { duration: 0.05, visibility: "hidden" })
        .to("#hero #title .tag-line .line ", { duration: 0.05, visibility: "visible" })
        .to("#hero #title .tag-line .line ", { duration: 0.05, visibility: "hidden" })
        .to("#hero #title .tag-line .line ", { duration: 0.05, visibility: "visible" })
        .set("#hero video", { fontStyle: "normal", display: "inline-block" })
        .add("l2")
        .to(
          "#hero #title .tag-line .text .figure",
          { stagger: 0.015, visibility: "visible", ease: "power4.inOut" },
          "l2"
        )
        .to(
          "#hero #title .tag-line .line ",
          {
            duration: 0.4,
            x: 0,
            ease: "power4.out",
            onStart: () => {
              var intro = document.querySelector("#hero #intro") as HTMLVideoElement,
                loop = document.querySelector("#hero #loop") as HTMLVideoElement
              gsap.set("#hero .scroll-icon", { visibility: "visible" })
              intro.play()
              loop.play()
            },
          },
          "l2"
        )
      // .set("#___gatsby", { pointerEvents: "all" })
    })
    if (window.innerWidth < window.innerHeight) {
      starter.play()
    }
    // else {
    //   // console.log("Portrait")
    // }
    //#endregion
    //**TODO --------------- SKills --------------- */
    //#region [c3]
    type nextSlide = "development" | "email" | "animation" | "motion"
    type prevSlide = "design" | "development" | "email" | "animation"
    var skillIcons = gsap
      .timeline({ paused: true, totalDuration: 1, defaults: { ease: "none" } })
      .add("l1")
      .to(["#skills .icon-row-0", "#skills .icon-row-2"], { duration: 1, x: "-400vw" }, "l1")
      .to("#skills .icon-row-1", { duration: 1, x: "400vw" }, "l1")
    const textDisapper = (el: string) => {
      var tl = gsap.to(`#skills #${el}-slide .figure`, {
        y: "100%",
        rotate: 30,
        opacity: 0,
        stagger: { each: 0.01, from: "end" },
      })
      return tl.totalDuration(1)
    }
    const textReveal = (el: string) => {
      var tl = gsap.to(`#skills #${el}-slide .figure`, {
        y: "0%",
        rotate: 0,
        opacity: 1,
        stagger: { each: 0.02, from: "start" },
      })
      return tl.totalDuration(0.5)
    }
    const skillsTitle = {
      reveal: {
        development: textReveal("development"),
        email: textReveal("email"),
        animation: textReveal("animation"),
        motion: textReveal("motion"),
      },
      disappear: {
        design: textDisapper("design"),
        development: textDisapper("development"),
        email: textDisapper("email"),
        animation: textDisapper("animation"),
      },
    }
    const skillsTween = (current: nextSlide, prev: prevSlide, icons: number) => {
      var Col = color.skills[current],
        tl = gsap
          .timeline({ defaults: { ease: "none", duration: 1 } })
          .add("l1")
          //** ------------ Text Animation ---------------  */
          .add(skillsTitle.disappear[prev], "l1")
          .add(skillsTitle.reveal[current], "l1+=0.5")
          //** ------------ Videos ---------------  */
          .to(`#skills video.${prev}`, { opacity: 0 }, "l1")
          .set(`#skills video.${prev}`, { display: "none", fontStyle: "initial" })
          .set(`#skills video.${current}`, { delay: -0.3, fontStyle: "normal" })
          //** ------------ Changing Colors ---------------  */
          .to("#skills-title-svg .cls-2", { stroke: Col.background }, "l1")
          .to("#skills-title-svg .cls-3", { fill: Col.background }, "l1")
          .to("#skills-title-svg .cls-1", { fill: Col.primary }, "l1")
          .to("#skills .section-title", { backgroundColor: Col.primary }, "l1")
          .to("#skills .border", { borderColor: Col.primary }, "l1")
          .to("#skills .icons-connect-lines", { backgroundColor: Col.primary }, "l1")
          .to("#skills .icon-back-line", { backgroundColor: Col.background }, "l1")
          //** ------------  Icons ---------------  */
          .to(skillIcons, { progress: icons / 4 }, "l1")
          //** ------------  Plus Button ---------------  */
          .to("#plus-container #plus-button", { backgroundColor: Col.background }, "l1")
          .to("#plus-container #plus-button .text", { backgroundColor: Col.primary }, "l1")
          .set(BrowserBar, { delay: -0.1, attr: { content: Col.background } })
          //** ------------  Description ---------------  */
          .to(`#skills #${prev}-slide .description`, { opacity: 0 }, "l1")
          .to(`#skills #${current}-slide .description`, { opacity: 1 }, "l1")

      return tl.totalDuration(1)
    }
    var development = skillsTween("development", "design", 1),
      email = skillsTween("email", "development", 2),
      animation = skillsTween("animation", "email", 3),
      motion = skillsTween("motion", "animation", 4)

    const skillsScrub = () => {
      var tl = gsap
        .timeline({
          defaults: { ease: "none" },
        })
        .add("l1")
        .add(development)
        .add(email)
        .add(animation)
        .add(motion)
        .to("#skills-title-svg .cls-1", { duration: 4, x: "100%" }, "l1")
      return tl.totalDuration(slides.skills[1])
    }
    //#endregion
    //**TODO --------------- Quality --------------- */
    //#region [c3]
    // var qualtystager = () => {
    //     var tl = gsap.to("#quality .parts .figure", { stagger: 0.1, visibility: "visible" })
    //     return tl.duration(1)
    //   },
    //   qualtyTextReveal = qualtystager()

    const qualityScrub = () => {
      var tl = gsap
        .timeline({ delay: 2, defaults: { ease: "none", duration: 1 } })
        // .add("l1")
        // .add(qualtyTextReveal, "l1")
        .add("l2")
        .to("#quality .parts .q", { scale: 15, x: "-3.6em", y: "2em" }, "l2")
        .to("#quality .parts ", { scale: 0.5, x: "27%", y: "-10%" }, "l2")
        .to("#quality .parts .line-0 ", { x: "-13%" }, "l2")
        .to("#quality .parts .line-2 ", { x: "0%" }, "l2")
        .to("#quality .parts .line-3 ", { x: "0%" }, "l2")
        .to("#quality .uality .figure", { delay: 0.5, duration: 0.45, x: "0%" }, "l2")
      // .add("l3")
      return tl.totalDuration(slides.quality[1])
    }
    //#endregion
    //**TODO --------------- Showcase --------------- */
    //#region [c3]
    var showMotion = color.showcase.motion
    var showcaseSlides = gsap
      .timeline({ defaults: { ease: "none", duration: 1 } })
      .add("l1")
      .set("#showcase video.websites", { display: "initial" })
      .to("#showcase video.websites", { opacity: 1, fontStyle: "normal" }, "l1")
      .set("#showcase video.websites", { fontStyle: "normal" })
      .add("l2")
      .to("#plus-container #plus-button", { backgroundColor: showMotion.background }, "l2")
      .to("#plus-button .text", { backgroundColor: showMotion.primary }, "l2")
      .set(BrowserBar, { delay: -0.1, attr: { content: showMotion.background } })
      .to("#showcase-title-svg .cls-2", { stroke: showMotion.background }, "l2")
      .to("#showcase-title-svg .cls-3", { fill: showMotion.background }, "l2")
      .to("#showcase-title-svg .cls-1", { fill: showMotion.primary }, "l2")
      .to("#showcase .slides-container", { backgroundColor: showMotion.background }, "l2")
      .to("#showcase .border", { borderColor: showMotion.primary }, "l2")
      .to("#showcase .section-title", { backgroundColor: showMotion.primary }, "l2")
      .to("#showcase ", {}, "l2")
      .to("#showcase video.websites", { duration: 0.5, opacity: 0 }, "l2")
      .set("#showcase video.websites", { display: "none", fontStyle: "initial" })
      .set("#showcase video.motion", { display: "initial" })
      .add("l3")
      .to("#showcase video.motion", { opacity: 1, fontStyle: "normal" }, "l3")
    const showcaseScrub = () => {
      var tl = gsap
        .timeline({ defaults: { ease: "none" } })
        .add("l1")
        .to("#showcase-title-svg .cls-1", { duration: 3, x: "100%" }, "l1")
        // .to("#showcase .slides-holder", { duration: 3, y: vh(-350) }, "l1")
        .to("#showcase .slides-holder", { duration: 3, y: "-75%" }, "l1")
        .add(showcaseSlides, "l1")
      return tl.totalDuration(slides.showcase[1])
    }

    //#endregion
    //**TODO --------------- Tools --------------- */
    //#region [c3]
    const toolsSlides = gsap
      .timeline({ defaults: { ease: "none", duration: 1 } })
      // .set("#tools .title", { color: color.tools.background.design })
      .add("l1")
      .to(
        ["#tools .slide-background", "#tools .slides-container", "#tools-title-svg .cls-3"],
        {
          backgroundColor: color.tools.background.development,
          fill: color.tools.background.development,
          color: color.tools.background.development,
        },
        "l1"
      )
      .to("#tools .titel", { color: color.tools.background.development }, "l1")
      .to("#tools-title-svg .cls-2", { stroke: color.tools.background.development }, "l1")
      .to(
        "#plus-container #plus-button ",
        { backgroundColor: color.tools.background.development },
        "l1"
      )
      .to(BrowserBar, { attr: { content: color.tools.background.development } }, "l1")
      .add("l2")
      .to(
        ["#tools .slide-background", "#tools .slides-container", "#tools-title-svg .cls-3"],
        {
          backgroundColor: color.tools.background.motion,
          fill: color.tools.background.motion,
          color: color.tools.background.motion,
        },
        "l2"
      )
      .to("#tools .titel", { color: color.tools.background.motion }, "l2")
      .to("#tools-title-svg .cls-2", { stroke: color.tools.background.motion }, "l2")
      .to("#plus-container #plus-button ", { backgroundColor: color.tools.background.motion }, "l2")
      .to(BrowserBar, { attr: { content: color.tools.background.motion } }, "l2")
    const toolsScrub = () => {
      var tl = gsap
        .timeline({ defaults: { ease: "none", duration: 1 } })
        .add("l1")
        .add(toolsSlides)
        .to("#tools-title-svg .cls-1", { duration: 2, x: "100%" }, "l1")
        .to("#tools .slides-holder", { duration: 2, y: "-83%" }, "l1")
      return tl.totalDuration(slides.tools[1])
    }

    //#endregion
    //**TODO --------------- Contact --------------- */
    //#region [c3]

    //#endregion

    //**?--------------- Sections Collector --------------- */
    //#region [c2]
    var scrub = {
      skills: skillsScrub(),
      quality: qualityScrub(),
      tools: toolsScrub(),
      showcase: showcaseScrub(),
    }
    const timeline = () => {
      var tl = gsap
        .timeline({
          paused: true,
          defaults: { ease: "none" },
          // onUpdate: () => {
          //   var videos = document.querySelectorAll("video")
          //   for (let i = 0; i < videos.length; i++) {
          //     var visiblity = videos[i].style.fontStyle
          //     if (i !== 1) {
          //       if (visiblity === "normal") {
          //         gsap.delayedCall(0.01, () => {
          //           videos[i].play()
          //         })
          //         // console.log(i, "played 🍏🍏🍏🍏🍏")
          //       } else {
          //         gsap.delayedCall(0.01, () => {
          //           videos[i].pause()
          //         })
          //         // console.log(i, "paused 🍎🍎🍎🍎🍎")
          //       }
          //     }
          //   }
          // },
        })

        .add(reveal.skills)
        .set("#skills .design-slide-video", { delay: -20, fontStyle: "normal" })
        .add(scrub.skills)

        .add(reveal.quality)
        .add(scrub.quality)

        .add(reveal.showcase)
        .add(scrub.showcase)

        .add(reveal.tools)
        .add(scrub.tools)

        .add(reveal.contacts)
        .to("#orientation", {
          delay: -0.1,
          duration: 0.00001,
          onStart: () => {
            document.querySelector("#orientation")?.classList.add("on-Typing")
          },
        })
      return tl.totalDuration(1)
    }
    slidesTimeline = timeline()
    //#endregion
  }, [])

  return <Animation />
}

const Animation: React.FC = () => {
  const Holder = styled.div`
    .my-slides-container {
      opacity: 1 !important;
      ${rr("height", " !important", "calc( 90 * 0.01 * var(--device-height))")}
    }
    .hidden {
      visibility: hidden;
      pointer-events: none;
      height: 7vh !important;
    }
  `

  return (
    <Holder id="animator">
      <Swiper
        direction="vertical"
        // spaceBetween={10}
        // slidesPerView={1}
        effect="fade"
        speed={1000}
        longSwipesMs={1000}
        onTransitionStart={s => {
          gsap.to(slidesTimeline, {
            progress: s.progress,
            duration: 2,
            ease: "expo.out",
            id: "slide",
          })
          // console.log(s.progress)
        }}
        onTouchMove={s => {
          if (gsap.getById("slide")) {
            gsap.getById("slide").kill()
          }
          if (s.progress > progress) {
            //** Increase */
            gsap.to(slidesTimeline, { progress: "+=0.004", duration: 0.3 })
            progress = s.progress
            // console.log("increase", s.progress)
          }
          if (s.progress < progress) {
            //** decrease */
            gsap.to(slidesTimeline, { progress: "-=0.004", duration: 0.3 })
            progress = s.progress
            // console.log("decrease", s.progress)
          }
        }}
      >
        <SwiperSlide className="my-slides-container">
          <Hero />
          <Skills />
          <Quality />
          <Showcase />
          <Tools />
          <Contact />
          <SwiperSlide className="hidden"></SwiperSlide>
        </SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
        <SwiperSlide className="hidden"></SwiperSlide>
      </Swiper>
    </Holder>
  )
}

export default Animator
